import baseScmService from 'services/baseScmService';

const classCreationTrackerService = baseScmService.injectEndpoints({
  endpoints: (build) => ({
    getClassCreationTracker: build.query({
      query: (trackerId) => ({
        url: `/class-creation-trackers/${trackerId}`,
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetClassCreationTrackerQuery } = classCreationTrackerService;

export default classCreationTrackerService;
